export default __webpack_public_path__ + "static/En_ELIB_EzyMedical_Cont-585a115b3168c5230c82560d4e676b4a.pdf";